import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { logout } from "store/userSlice";

export default function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
  }, [dispatch])
  


  return <Navigate to="/" />;
}
